"use client";

import { Mail } from "lucide-react";



const EmailButton = ({
  email,
  subject = "Inquiry about your services",
  body = "Hello, I’d like to learn more about what you offer.",
  className = ""
}) => {
  const handleEmailClick = () => {
    const encodedSubject = encodeURIComponent(subject);
    const encodedBody = encodeURIComponent(body);
    const mailtoUrl = `mailto:${email}?subject=${encodedSubject}&body=${encodedBody}`;
    window.open(mailtoUrl, "_blank");
  };

  return (
    <button
      onClick={handleEmailClick}
      className={`
        h-12 w-72 flex items-center gap-2 px-6 py-3 
        bg-blue-600 hover:bg-blue-700 
        text-white font-medium rounded-lg
        transition-colors duration-200
        shadow-lg hover:shadow-xl
        
        ${className}
      `}
    >
      <Mail size={20} />
      Send us an Email
    </button>
  );
};

export default EmailButton;
